export default {
  BAR_CHART: 'BAR CHART',
  BUBBLE_CHART: 'BUBBLE CHART',
  LABEL_CHART_BOTTOM: 'Today Trading Volume / Avg. Trading Volume past 5D',
  LABEL_CHART_LEFT: 'Contribution to INDEX (%)',
  LABEL_CHART_TOP: 'TOP INFLUENTIAL STOCKS TO INDEX',

  timeRange: {
    CONTRIB_1DAY: '1 DAY',
    CONTRIB_5DAY: '5 DAYS',
    CONTRIB_10DAY: '10 DAYS',
    CONTRIB_20DAY: '20 DAYS',
  },
  CONTRIBUTION: 'Contribution',
  MATCHED: 'Matched',
  VOLUME: 'Volume',
  VALUE: 'Value',

  contributionType: {
    Total: ' Outstanding Shares',
    FreeFloat: 'Free Float',
  },
  contributionTypeTooltip: {
    Total:
      'Contribution is calculated by Market Capitalization based on Outstanding Shares',
    FreeFloat:
      'Contribution is calculated by Market Capitalization based on Free-Float Shares',
  },
};
